module.exports = {"TXTWCL_RatingX_N0_out_of_N1_stars":{"id":"TXTWCL_RatingX_N0_out_of_N1_stars","defaultMessage":"Bewertung: {0} von {1} Sternen"}}